// @ts-nocheck
import { BigNumber } from "ethers";
import { useSingleCallResult } from "lib/hooks/multicall";
import { useMemo } from "react";
import { useVaultManagerContract } from "./useContract";

/**
 * Getting the current DoubleDownClub contract
 */
export default function useVaultManager(currency, amount): { loading: boolean; supplyAllowance: BigNumber; capPerDDC: BigNumber} {
    const inputs = useMemo(() => [currency ?? undefined, amount], [currency, amount])
    const pool = window.localStorage.getItem('SELECT_POOL') || 'Ubeswap'
    const vaultContract = useVaultManagerContract(pool.toLowerCase(), false)
    const capitalAmount = useSingleCallResult(vaultContract, 'convertCapitalToUSD', inputs)
    return useMemo(
        () => ({
            capitalInUSD: capitalAmount.result?.[0] ?? BigNumber.from('0'),
            loading: false,
        }),
        [capitalAmount.result]
    )
}
